<template>
  <div class="hello">
    <div style="position: absolute; top: 10px; left: 0;">
      <!-- 选择模板打开 -->
      <!-- <div style="width: 400px; height: 50px;">
        <span>选择模板文件: </span>
        <select v-model="selected" @change="selectExcel">
          <option disabled value="">Choose</option>
          <option
            v-for="option in options"
            :key="option.text"
            :value="option.value"
          >
            {{ option.text }}
          </option>
        </select>
      </div> -->

      <!-- 打开本地文件 -->
      <!-- <div style="width: 130px; height: 50px; float: left;">
        <label
          for="upload"
          style="padding: 10px; line-height: 20px; background: #00bfff; border-radius: 4px; color: white; cursor: pointer;"
        >
          选择本地文件
        </label>
        <input
          type="file"
          id="upload"
          style="display: none;"
          @change="openExcel"
        />
      </div> -->

      <!-- 保存导出文件 -->
      <!-- <div style="width: 130px; float: left;">
        <label
          style="padding: 10px; line-height: 20px; background: #00bfff; border-radius: 4px; color: white; cursor: pointer;"
          @click="downloadExcel"
        >
          保存导出文件
        </label>
      </div> -->

      <div style="clear: both;"></div>

      <!-- <div>文件名：{{ fileName }}</div> -->
    </div>

    <div
      id="luckysheet"
      style="margin: 0px; padding: 0px; position: absolute; width: 100%; left: 0px; top: 0px; bottom: 0px;"
    ></div>

    <div
      v-show="isMaskShow"
      style="position: absolute;z-index: 1000000;left: 0px;top: 0px;bottom: 0px;right: 0px; background: rgba(255, 255, 255, 0.8); text-align: center;font-size: 40px;align-items:center;justify-content: center;display:flex;"
    >
      Downloading
    </div>
  </div>
</template>

<script>
import LuckyExcel from "luckyexcel";
// import { exportExcel } from "@/utils/export";
import { exportExcelFront, saveOriginalFile } from "@/utils/export2";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      selected: "",
      options: [
        {
          text: "Money Manager",
          value:
            "https://minio.cnbabylon.com/public/luckysheet/money-manager-2.xlsx",
        },
        {
          text: "Activity costs tracker",
          value:
            "https://minio.cnbabylon.com/public/luckysheet/Activity%20costs%20tracker.xlsx",
        },
        {
          text: "House cleaning checklist",
          value:
            "https://minio.cnbabylon.com/public/luckysheet/House%20cleaning%20checklist.xlsx",
        },
        {
          text: "Student assignment planner",
          value:
            "https://minio.cnbabylon.com/public/luckysheet/Student%20assignment%20planner.xlsx",
        },
        {
          text: "Credit card tracker",
          value:
            "https://minio.cnbabylon.com/public/luckysheet/Credit%20card%20tracker.xlsx",
        },
        {
          text: "Blue timesheet",
          value:
            "https://minio.cnbabylon.com/public/luckysheet/Blue%20timesheet.xlsx",
        },
        {
          text: "Student calendar (Mon)",
          value:
            "https://minio.cnbabylon.com/public/luckysheet/Student%20calendar%20%28Mon%29.xlsx",
        },
        {
          text: "Blue mileage and expense report",
          value:
            "https://minio.cnbabylon.com/public/luckysheet/Blue%20mileage%20and%20expense%20report.xlsx",
        },
      ],
      isMaskShow: false,
      fileName: "new.xlsx",
      excelBlob: null,
      tempExcelBlob: null,
      appName: null,
      appBundleId: null,
      appStoreVersion: "",
      appUserId: null,
    };
  },
  mounted() {
    // this.init();
    window.initParam = this.initParam;
    window.getExcelJson = this.getExcelJson;
    window.saveExcel = this.saveExcel;
    window.saveExcelV2 = this.saveExcelV2;
    window.getExcelBase64 = this.getExcelBase64;
    window.openExcelByBase64 = this.openExcelByBase64;
    window.openExcelByUrl = this.openExcelByUrl;
    window.buildTempBase64 = this.buildTempBase64;
    window.getTempBase64 = this.getTempBase64;
  },
  methods: {
    // 初始化参数
    initParam(appName, appBundleId, appStoreVersion, appUserId) {
      this.appName = appName;
      this.appBundleId = appBundleId;
      this.appStoreVersion = appStoreVersion;
      this.appUserId = appUserId;
    },
    // 获取表格数据（JSON）
    getExcelJson() {
      return window.luckysheet.getAllSheets();
    },
    // 保存表格数据（base64）（设置到变量/保存到服务器）
    saveExcel(appName, appBundleId, appUserId, fileId, fileName) {
      // console.log("param", appName, appBundleId, appUserId, fileId, fileName);
      const formData = new FormData();
      formData.append("appName", appName);
      formData.append("appBundleId", appBundleId);
      formData.append("appStoreVersion", this.appStoreVersion);
      formData.append("appUserId", appUserId);
      formData.append("fileId", fileId);
      if (fileName.indexOf(".xlsx") === -1) {
        formData.append("fileName", fileName + ".xlsx");
      } else {
        formData.append("fileName", fileName);
      }
      var _that = this;
      _that.fileName = fileName;
      exportExcelFront(window.luckysheet.getAllSheets(), formData).then(
        (res) => {
          _that.excelBlob = res;
        }
      );
      return "success";
    },
    // 保存表格数据（V2）
    saveExcelV2(fileId, fileName) {
      this.saveExcel(
        this.appName,
        this.appBundleId,
        this.appUserId,
        fileId,
        fileName
      );
    },
    // 获取表格数据（base64）
    getExcelBase64() {
      return this.excelBlob.toString("base64");
    },
    // 生成表格临时数据
    buildTempBase64() {
      var _that = this;
      exportExcelFront(window.luckysheet.getAllSheets(), null).then((res) => {
        _that.tempExcelBlob = res;
      });
      return "success";
    },
    // 获取表格临时数据
    getTempBase64() {
      return this.tempExcelBlob.toString("base64");
    },

    // 初始化
    init() {
      // In some cases, you need to use $nextTick
      // this.$nextTick(() => {
      // $(function() {
      window.luckysheet.create({
        container: "luckysheet", // 设定DOM容器的id
        showinfobar: false,
        enableAddRow: false,
        enableAddBackTop: false,
        showtoolbarConfig: {
          exportXlsx: false,
        },
        lang: "en", // 设定表格语言
        plugins: [{ name: "chart" }],
        loading: {
          image: () => {
            return `<svg viewBox="25 25 50 50" class="circular">
					<circle cx="50" cy="50" r="20" fill="none"></circle>
					</svg>`;
          },
          imageClass: "loadingAnimation",
        },
        title: this.fileName, // 设定表格名称
        data: [
          {
            name: "Sheet1", //工作表名称
            color: "", //工作表颜色
            index: 0, //工作表索引
            status: 1, //激活状态
            order: 0, //工作表的下标
            hide: 0, //是否隐藏
            row: 100, //行数
            column: 18, //列数
            defaultRowHeight: 19, //自定义行高
            defaultColWidth: 73, //自定义列宽
            celldata: [], //初始化使用的单元格数据
            config: {
              merge: {}, //合并单元格
              rowlen: {}, //表格行高
              columnlen: {}, //表格列宽
              rowhidden: {}, //隐藏行
              colhidden: {}, //隐藏列
              borderInfo: [], //边框
              authority: {}, //工作表保护
            },
            scrollLeft: 0, //左右滚动条位置
            scrollTop: 0, //上下滚动条位置
            luckysheet_select_save: [], //选中的区域
            calcChain: [], //公式链
            isPivotTable: false, //是否数据透视表
            pivotTable: {}, //数据透视表设置
            filter_select: {}, //筛选范围
            filter: null, //筛选配置
            luckysheet_alternateformat_save: [], //交替颜色
            luckysheet_alternateformat_save_modelCustom: [], //自定义交替颜色
            luckysheet_conditionformat_save: {}, //条件格式
            frozen: {}, //冻结行列配置
            chart: [], //图表配置
            zoomRatio: 1, // 缩放比例
            image: [], //图片
            showGridLines: 1, //是否显示网格线
            dataVerification: {}, //数据验证配置
          },
          {
            name: "Sheet2",
            color: "",
            index: 1,
            status: 0,
            order: 1,
            row: 100, //行数
            column: 18, //列数
            celldata: [],
            config: {},
          },
          {
            name: "Sheet3",
            color: "",
            index: 2,
            status: 0,
            order: 2,
            row: 100, //行数
            column: 18, //列数
            celldata: [],
            config: {},
          },
        ],
      });
      // });
      // });
    },
    base64ToFile(base64, fileName) {
      // let arr = base64.split(",");
      // let mime = arr[0].match(/:(.\*?);/)[1];
      // let bstr = atob(arr[1]);
      let bstr = atob(base64);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      });
    },
    // 打开本地文件 (fileName.indexOf(".xlsx") === -1 && fileName.indexOf(".xls") !== -1)
    openExcelByBase64(base64, fileName) {
      if (base64 === "" || base64 === null || base64 === undefined) {
        this.init();
      } else {
        if (fileName.indexOf(".xlsx") === -1) {
          fileName = fileName + ".xlsx";
        }
        // const files = evt.target.files;
        let files = [];
        const file = this.base64ToFile(base64, fileName);
        files.push(file);
        if (files == null || files.length == 0) {
          alert("No files wait for import");
          return;
        }

        // 保存原文件
        saveOriginalFile(file, fileName);

        let _that = this;
        let name = files[0].name;
        let suffixArr = name.split("."),
          suffix = suffixArr[suffixArr.length - 1];
        if (suffix != "xlsx") {
          alert("Currently only supports the import of xlsx files");
          return;
        }
        LuckyExcel.transformExcelToLucky(files[0], function(
          exportJson,
          luckysheetfile
        ) {
          // console.log(luckysheetfile);
          if (exportJson.sheets == null || exportJson.sheets.length == 0) {
            alert(
              "Failed to read the content of the excel file, currently does not support xls files!"
            );
            return;
          }
          window.luckysheet.destroy();

          _that.fileName = exportJson.info.name;
          window.luckysheet.create({
            container: "luckysheet", //luckysheet is the container id
            showinfobar: false,
            enableAddRow: false,
            enableAddBackTop: false,
            showtoolbarConfig: {
              exportXlsx: false,
            },
            lang: "en", // 设定表格语言
            plugins: [{ name: "chart" }],
            loading: {
              image: () => {
                return `<svg viewBox="25 25 50 50" class="circular">
      		<circle cx="50" cy="50" r="20" fill="none"></circle>
      		</svg>`;
              },
              imageClass: "loadingAnimation",
            },
            title: exportJson.info.name,
            data: exportJson.sheets,
            userInfo: exportJson.info.name.creator,
          });
        });
      }
    },
    // 打开网络文件
    openExcelByUrl(fileUrl, fileName) {
      if (fileUrl === "" || fileUrl === null || fileUrl === undefined) {
        this.init();
      } else {
        this.isMaskShow = true;

        LuckyExcel.transformExcelToLuckyByUrl(
          fileUrl,
          fileName,
          (exportJson, luckysheetfile) => {
            if (exportJson.sheets == null || exportJson.sheets.length == 0) {
              alert(
                "Failed to read the content of the excel file, currently does not support xls files!"
              );
              return;
            }

            this.isMaskShow = false;
            window.luckysheet.destroy();

            this.fileName = exportJson.info.name;
            window.luckysheet.create({
              container: "luckysheet", //luckysheet is the container id
              showinfobar: false,
              enableAddRow: false,
              enableAddBackTop: false,
              showtoolbarConfig: {
                exportXlsx: false,
              },
              lang: "en", // 设定表格语言
              plugins: [{ name: "chart" }],
              loading: {
                image: () => {
                  return `<svg viewBox="25 25 50 50" class="circular">
					<circle cx="50" cy="50" r="20" fill="none"></circle>
					</svg>`;
                },
                imageClass: "loadingAnimation",
              },
              title: exportJson.info.name,
              data: exportJson.sheets,
              userInfo: exportJson.info.name.creator,
            });
          }
        );
      }
    },
    // 打开本地文件
    openExcel(evt) {
      const files = evt.target.files;
      if (files == null || files.length == 0) {
        alert("No files wait for import");
        return;
      }

      let _that = this;
      let name = files[0].name;
      let suffixArr = name.split("."),
        suffix = suffixArr[suffixArr.length - 1];
      if (suffix != "xlsx") {
        alert("Currently only supports the import of xlsx files");
        return;
      }
      LuckyExcel.transformExcelToLucky(files[0], function(
        exportJson,
        luckysheetfile
      ) {
        // console.log(luckysheetfile);
        if (exportJson.sheets == null || exportJson.sheets.length == 0) {
          alert(
            "Failed to read the content of the excel file, currently does not support xls files!"
          );
          return;
        }
        window.luckysheet.destroy();

        _that.fileName = exportJson.info.name;
        window.luckysheet.create({
          container: "luckysheet", //luckysheet is the container id
          showinfobar: false,
          enableAddRow: false,
          enableAddBackTop: false,
          showtoolbarConfig: {
            exportXlsx: false,
          },
          lang: "en", // 设定表格语言
          plugins: [{ name: "chart" }],
          loading: {
            image: () => {
              return `<svg viewBox="25 25 50 50" class="circular">
      		<circle cx="50" cy="50" r="20" fill="none"></circle>
      		</svg>`;
            },
            imageClass: "loadingAnimation",
          },
          title: exportJson.info.name,
          data: exportJson.sheets,
          userInfo: exportJson.info.name.creator,
        });
      });
    },
    // 选择模板文件
    selectExcel(evt) {
      const value = this.selected;
      const name = evt.target.options[evt.target.selectedIndex].innerText;

      if (value == "") {
        return;
      }
      this.isMaskShow = true;

      LuckyExcel.transformExcelToLuckyByUrl(
        value,
        name,
        (exportJson, luckysheetfile) => {
          if (exportJson.sheets == null || exportJson.sheets.length == 0) {
            alert(
              "Failed to read the content of the excel file, currently does not support xls files!"
            );
            return;
          }

          this.isMaskShow = false;
          window.luckysheet.destroy();

          this.fileName = exportJson.info.name;
          window.luckysheet.create({
            container: "luckysheet", //luckysheet is the container id
            showinfobar: false,
            enableAddRow: false,
            enableAddBackTop: false,
            showtoolbarConfig: {
              exportXlsx: false,
            },
            lang: "en", // 设定表格语言
            plugins: [{ name: "chart" }],
            loading: {
              image: () => {
                return `<svg viewBox="25 25 50 50" class="circular">
					<circle cx="50" cy="50" r="20" fill="none"></circle>
					</svg>`;
              },
              imageClass: "loadingAnimation",
            },
            title: exportJson.info.name,
            data: exportJson.sheets,
            userInfo: exportJson.info.name.creator,
          });
        }
      );
    },
    // 保存导出文件
    downloadExcel() {
      // console.log(window.luckysheet.getAllSheets());
      // console.log(window.luckysheet.getluckysheetfile());
      // console.log(this.fileName);
      // exportExcelFront(
      //   window.luckysheet.getAllSheets(),
      //   this.fileName.replace(".xlsx", "")
      // );
      // const value = this.selected;
      // if (value.length == 0) {
      //   alert("Please select a demo file");
      //   return;
      // }
      // var elemIF = document.getElementById("Lucky-download-frame");
      // if (elemIF == null) {
      //   elemIF = document.createElement("iframe");
      //   elemIF.style.display = "none";
      //   elemIF.id = "Lucky-download-frame";
      //   document.body.appendChild(elemIF);
      // }
      // elemIF.src = value;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
<style>
@keyframes loading-rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}
.loadingAnimation {
  width: 3em;
  height: 3em;
  animation: loading-rotate 2s linear infinite;
}
.loadingAnimation circle {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: currentColor;
  stroke-linecap: round;
}
/* #luckysheet-icon-morebtn {
  position: relative;
  right: 0px;
  margin-left: 50px;
} */
.luckysheet-stat-area {
  background: #ffffff;
}
#luckysheet-icon-morebtn-div {
  right: 0px !important;
  left: 0px;
}
#luckysheet-tooltip-up {
  display: none;
}
</style>
